"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
exports.default = (theme) => (0, styles_1.createStyles)({
    screenCard: {
        marginTop: theme.spacing(4)
    },
    cardContent: {
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing()
        }
    },
    cardContentInner: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        [theme.breakpoints.down('xs')]: {
            paddingBottom: theme.spacing(2)
        },
        [theme.breakpoints.up('sm')]: {
            paddingBottom: theme.spacing(5)
        }
    },
    title: {
        textAlign: 'center',
        [theme.breakpoints.down('xs')]: {
            marginTop: 24,
            marginBottom: 16
        },
        [theme.breakpoints.up('sm')]: {
            marginTop: 32,
            marginBottom: 32
        }
    }
});
//# sourceMappingURL=ScreenCardStyle.js.map